/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.13.2
 */
export const CSS = {
    container: "container",
    handle: "handle",
};
export const ICON_TYPES = {
    grip: "grip",
};
export const TEXT = {
    filterResults: "Filter results",
};
//# sourceMappingURL=resources.js.map
